import EFOcats_logic from '../efocats_logic.js';

/**
 * 分岐判定クラス
 */
export default class EFOcats_branch_core extends EFOcats_logic {
  /**
   * 条件判定
   */
  checkCondition(condition) {
    // 子クラスで実装
  }
}
